// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"460":"6d13cb4793caf885","498":"6d13cb4793caf885","653":"6d13cb4793caf885","888":"2a48573d45b169c2"}[chunkId] + ".css";
};